import { render, staticRenderFns } from "./BoxItemVenta.vue?vue&type=template&id=1da2db6d&"
import script from "./BoxItemVenta.vue?vue&type=script&lang=js&"
export * from "./BoxItemVenta.vue?vue&type=script&lang=js&"
import style0 from "./BoxItemVenta.vue?vue&type=style&index=0&id=1da2db6d&prod&lang=css&"
import style1 from "./BoxItemVenta.vue?vue&type=style&index=1&id=1da2db6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports